import { VisitDocument } from '@precheckin/models/visit-document/visit-document.model';

export interface IPrecheckinVisitDocumentStateModel {
  isVisitDocumentReady: boolean;
  passport: VisitDocument;
  pilotLicenses: VisitDocument[];
  medicalCertificates: VisitDocument[];
  visa: VisitDocument;
  isPassportPagesReady: boolean;
  isLicensePagesReady: boolean;
  isMedicalCertificatesPagesReady: boolean;
  isVisaPagesReady: boolean;
  hasTriedToUploadPages: boolean;
}

export const deafultVisitDocumentState = {
  isVisitDocumentReady: false,
  passport: new VisitDocument(),
  pilotLicenses: new Array<VisitDocument>(),
  medicalCertificates: new Array<VisitDocument>(),
  visa: new VisitDocument(),
  isPassportPagesReady: false,
  isLicensePagesReady: false,
  isMedicalCertificatesPagesReady: false,
  isVisaPagesReady: false,
  hasTriedToUploadPages: false
} as IPrecheckinVisitDocumentStateModel;
